function headings(event, keysPressed) {
  // works only on czech keyboard
  // todo: english keyboard

  if (keysPressed && keysPressed['Control'] && event.key == '+') {
    event.preventDefault();
    document.execCommand('formatBlock', false, "<h1>");
  }

  if (keysPressed && keysPressed['Control'] && event.key == 'ě') {
    event.preventDefault();
    document.execCommand('formatBlock', false, "<h2>");
  }

  if (keysPressed && keysPressed['Control'] && event.key == 'š') {
    event.preventDefault();
    document.execCommand('formatBlock', false, "<h3>");
  }

  if (keysPressed && keysPressed['Control'] && event.key == 'č') {
    event.preventDefault();
    document.execCommand('formatBlock', false, "<h4>");
  }

  if (keysPressed && keysPressed['Control'] && event.key == 'ř') {
    event.preventDefault();
    document.execCommand('formatBlock', false, "<h5>");
  }
  if (keysPressed && keysPressed['Control'] && event.key == 'ž') {
    event.preventDefault();
    document.execCommand('formatBlock', false, "<h6>");
  }
}

export { headings }